module.exports = __webpack_public_path__ + "static/media/iconPaymentHistory.19aa7632.svg";